import type { ReactElement } from 'react';
import { createElement } from 'react';
import { DevModePicker } from 'components/dev-mode-picker';

const DEV_MODE_NAME = 'dev-mode';

const devModeEnabled = () => import.meta.env.VITE_DEV_MODE_ENABLED === 'true';

export const getIsDevModeFlag = (): boolean => {
  const isDevModeEnabled = devModeEnabled();

  const devMode = localStorage.getItem(DEV_MODE_NAME);
  return devMode && isDevModeEnabled ? JSON.parse(devMode) : false;
};

export const initDevMode = (): ReactElement | null => {
  const isDevMode = getIsDevModeFlag();

  if (isDevMode) {
    window.$isDevMode = isDevMode;
  }

  const isDevModeEnabled = devModeEnabled();
  if (!isDevModeEnabled) return null;

  return createElement(DevModePicker, { localStorageName: DEV_MODE_NAME, isDevMode });
};
